module.exports = __webpack_public_path__ + "static/media/scorm.8de894f2.svg";